import { createAction } from '@mendeley-internal/lib-js-redux-actions';
import api from '../services/api/request';

const limit = 5;

export const getRecommendations = createAction(
  'GET_RECOMMENDATIONS',
  documentId => api.get(`recommendations/${documentId}`, { params: { limit } }).setCritical(false),
  documentId => ({ documentId })
);



// WEBPACK FOOTER //
// ./src/universal/ui/actions/recommendations.js